import { render, staticRenderFns } from "./DSHomeIcon.vue?vue&type=template&id=0da02906&scoped=true&"
import script from "./DSHomeIcon.vue?vue&type=script&lang=js&"
export * from "./DSHomeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da02906",
  null
  
)

export default component.exports